// extracted by mini-css-extract-plugin
export default {"input":"styles_input__ZqWxD","label":"styles_label__LnD55","errorMessage":"styles_errorMessage__X8xhv"};